import { Injectable } from '@angular/core';
import { Session } from './objects/Session';

@Injectable( {providedIn:'root'} )
export class Globals {
    Session: Session;
    CardItems:string[];
    CurrentActiveDetailId:string;
  }

@Injectable({providedIn:'root'})
export class TokenManager {

    public store(tokenKey:string, content:Object) {
        sessionStorage.setItem(tokenKey, JSON.stringify(content));
    }

    public retrieve(tokenKey:string) {
        let storedToken:string = sessionStorage.getItem(tokenKey);
        if(!storedToken) return null;
        return storedToken;
    }

    public retrieveToken(tokenKey:string) {

        let currentTime:number = (new Date()).getTime(), token = null;
        try {
            let storedToken = JSON.parse(this.retrieve(tokenKey));
            if(storedToken.ttl < currentTime) throw 'invalid token found';
            token = storedToken.token;
        }
        catch(err) {
            console.error(err);
        }
        return token;

    }

    public clear(){
        sessionStorage.clear();
      }

    public delete(tokenKey:string){
      sessionStorage.removeItem(tokenKey);
    }

}